(function () {
  const breakpoint = window.matchMedia("(max-width: 575px)");

  const initSlidersMobile = () => {
    const sliders = document.querySelectorAll(
      ".product-recommendations__slider:not(.swiper-initialized)"
    );

    sliders.forEach((slider) => {
      if (!breakpoint.matches) return;

      const mobileCols = Number(slider.dataset.mobileColumns || 1);
      const wrapper = slider.querySelector('.swiper-wrapper');
      if (!wrapper) return;

      wrapper.querySelectorAll('li').forEach((li) => li.classList.add('swiper-slide'));

      const pagination = slider.querySelector('.product-recommendations__pagination');

      const slidesPerView = mobileCols === 1 ? 1.25 : mobileCols;
      slider.swiperInstance = new Swiper(slider, {
        slidesPerView: slidesPerView,
        spaceBetween: 8,
        slidesPerGroup: 1,
        pagination: pagination
          ? { el: pagination, clickable: true }
          : undefined,
        watchOverflow: true,
      });
    });
  };

  const destroySlidersMobile = () => {
    const sliders = document.querySelectorAll(
      ".product-recommendations__slider.swiper-initialized"
    );

    sliders.forEach((slider) => {
      if (slider.swiper && typeof slider.swiper.destroy === 'function') {
        slider.swiper.destroy(true, true);
      }
      const wrapper = slider.querySelector('.swiper-wrapper');
      if (wrapper) wrapper.querySelectorAll('li').forEach((li) => li.classList.remove('swiper-slide'));
    });
  };

  const handle = () => {
    if (breakpoint.matches) {
      initSlidersMobile();
    } else {
      destroySlidersMobile();
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    handle();
    window.addEventListener('resize', handle);
    document.addEventListener('shopify:section:load', handle);
    document.addEventListener('product-recommendations:loaded', handle);
  });
})();
